import React, { FC } from 'react';
import { IMRBeaconSVGProps } from './icons.types';

const Document: FC<IMRBeaconSVGProps> = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="25"
      viewBox="0 0 20 25"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.207 5C19.3946 5.18749 19.4999 5.4418 19.5 5.707V23C19.5 23.5523 19.0523 24 18.5 24H1.5C0.947715 24 0.5 23.5523 0.5 23V2C0.5 1.44772 0.947715 1 1.5 1H14.793C15.0582 1.00006 15.3125 1.10545 15.5 1.293L19.207 5Z"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M4 16.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 19.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 13.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 10.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 7.5H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 7.5H11" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 10.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 13.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 16.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M4 19.5H16" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default Document;
